<template>
    <el-dialog
        :visible.sync="wxLoginVisible"
        :show-close="false"
        center
        width="350px"
        :before-close="handleClose">
        <div id="wxLoginDom">
            
        </div>
        

    </el-dialog>
   
</template>
<script>
export default {
    props:["wxLoginVisible"],
   data (){
       return {
           loginForm:{
               mobile:'',
                code:''
           }
           
       }
   },
   components: {
       
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       handleClose(){
           this.$emit("update:wxLoginVisible",false)
       },
       get_wx_qrcode(){
           //从微信的开发文档不难看出回调域名需要经过encodeURIComponent处理
            let call_back_domain_name = window.location.href,
            domain_name_length = call_back_domain_name.indexOf("#") - 1,
            DDNS = call_back_domain_name.substring(0, domain_name_length),
            DDNS_resolution = encodeURIComponent(DDNS);
            // var obj = new WxLogin({
            //     self_redirect: false,
            //     id: "login_container",       //需要承载二维码的容器id  
            //     appid: "wxa3f5e3ec4d3e90f3",
            //     scope: "snsapi_login",     //网页授权，目前网页只有这一种方式，静默授权
            //     redirect_uri: DDNS_resolution,     //回调域名
            //     state: Math.random(),
            //     style: "white",
            //     href: "",
            // })
            console.log(document.getElementById("wxLoginDom"));
            var obj = new WxLogin({
                self_redirect:false,

                id:"wxLoginDom", 

                appid:'wxa3f5e3ec4d3e90f3', 

                scope: "snsapi_login", 

                redirect_uri: encodeURIComponent("https://www.yangshif.com"),

                state: Math.random(),

                style: "black"
            })
       },
       test(){
           console.log(this.userInfo);
       },
        isPhoneNo(phone) {
            var pattern = /^[1][3-9][0-9]{9}$/;
            return pattern.test(phone);
        }  
   },
   created() {
       
   },
   mounted() {
       this.$nextTick(() => {
           this.get_wx_qrcode();   //获取微信的登录二维码
       });
       
   }
}
</script>

<style scoped lang='less'>
.login{
    padding: 0 35px;
    &_title{
        text-align: center;
        img{
            width:132px;
            margin-top:10px;
        }
    }
    &_input{
        margin-top:24px;
        position: relative;
        &_img1{
            width:20px;
            position: absolute;
            top: 16px;
            left: 16px;
            z-index:1;
        }
        /deep/ input{
            height:60px;
            font-size:20px;
            padding-left:54px;
        }
        
    }
    &_input2{
        margin-top:24px;
        position: relative;
        /deep/ input{
            height:60px;
            font-size:20px;
            padding-left:54px;
            padding-right:128px;
        }
        &_img2{
            width:30px;
            position: absolute;
            top: 16px;
            left: 14px;
            z-index:1;
        }
        &_code{
            height:34px;
            width:128px;
            border-left:1px solid #CFD7E0;
            padding-left:8px;
            position: absolute;
            right:0;
            top:13px;
            &_get{
                font-size: 20px;
                line-height: 34px;
                color:#009AFF;
                cursor: pointer;
            }
        }
    }
    &_btn{
        width:100%;
        margin-top:26px;
    }
    /deep/ &_btn.el-button{
        height: 54px;
        font-size: 18px;
        background:#5999FF;
    }
    &_handle{
        display: flex;
        justify-content: space-between;
        padding: 10px 0 30px 0;
        border-bottom:1px solid #F5F5F5;
        /deep/ .el-button--text{
            font-size:18px;
            color:#009AFF;
        }
    }
    &_type{
        text-align: center;
        margin-top:23px;
        img{
            width:58px;
            height: 46px;
            cursor: pointer;
        }
        p{
            color:#333;
            span{
                cursor: pointer;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/wxLogin.vue